<template>
    <div>
        <CRow><CCol tag="label" class="col-form-label">График работы</CCol></CRow>
        <div class="store-schedule">
            <CRow
                v-for="(day, index) of scheduleLocal"
                :key="index"
                class="store-schedule-item"
            >
                <CRow class="store-schedule-enable" style="margin-bottom: 10px;">
                    <span>{{ daysOfTheWeek[index] }}</span>
                    <CSwitch
                        name="dayEnabled"
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="day.enabled"
                        :change="$emit('set-schedule', scheduleLocal)"
                    />
                </CRow>
            </CRow>
        </div>
    </div>
</template>

<script>
    import { DAYS_OF_THE_WEEK, SCHEDULE } from '../utils/schedule';

    export default {
        props: {
            schedule: {
                type: Array,
                default: () => {
                    return SCHEDULE;
                },
            },
        },

        data: () => ({
            scheduleLocal: SCHEDULE,
            daysOfTheWeek: DAYS_OF_THE_WEEK,
        }),

        watch: {
            schedule: function() {
                this.setModel();
            }
        },

        created() {
            this.setModel();
        },

        methods: {
            setModel() {
                if(!this.schedule || !Array.isArray(this.schedule) || this.schedule.length === 0) {
                    this.scheduleLocal = SCHEDULE;
                } else {
                    this.scheduleLocal = this.schedule;
                }
            },
        },
    };
</script>
